import { stringify } from 'query-string';
import { createGetAPI } from '@cuemath/rest-api';

import { BASE_URL, BASE_URL_V2 } from 'constants/api';

const { useGet: useTeacherLicenseGet } = createGetAPI({
  getURL: (teacherId, query) =>
    `${BASE_URL_V2}/teachers/${teacherId}/licenses?${stringify(query)}`,
});

const { useGet: useTeacherTestGet } = createGetAPI({
  getURL: teacherId => `${BASE_URL}/teachers/applicant-cet/all/${teacherId}`,
});

export { useTeacherLicenseGet, useTeacherTestGet };
